<div *nzModalTitle></div>
<div class="modal-content">
  @if (isLoading) {
    <korviu-loader></korviu-loader>
  }
  <i nz-icon class="mb-4 lg:mb-6 sm:mb-4">
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
      <path
        d="M20 29.9999C20.5667 29.9999 21.0417 29.8082 21.425 29.4249C21.8083 29.0416 22 28.5666 22 27.9999C22 27.4332 21.8083 26.9582 21.425 26.5749C21.0417 26.1916 20.5667 25.9999 20 25.9999C19.4333 25.9999 18.9583 26.1916 18.575 26.5749C18.1917 26.9582 18 27.4332 18 27.9999C18 28.5666 18.1917 29.0416 18.575 29.4249C18.9583 29.8082 19.4333 29.9999 20 29.9999ZM18 21.9999H22V9.9999H18V21.9999ZM20 39.9999C17.2333 39.9999 14.6333 39.4749 12.2 38.4249C9.76667 37.3749 7.65 35.9499 5.85 34.1499C4.05 32.3499 2.625 30.2332 1.575 27.7999C0.525 25.3666 0 22.7666 0 19.9999C0 17.2332 0.525 14.6332 1.575 12.1999C2.625 9.76657 4.05 7.6499 5.85 5.8499C7.65 4.0499 9.76667 2.6249 12.2 1.5749C14.6333 0.524901 17.2333 -9.91821e-05 20 -9.91821e-05C22.7667 -9.91821e-05 25.3667 0.524901 27.8 1.5749C30.2333 2.6249 32.35 4.0499 34.15 5.8499C35.95 7.6499 37.375 9.76657 38.425 12.1999C39.475 14.6332 40 17.2332 40 19.9999C40 22.7666 39.475 25.3666 38.425 27.7999C37.375 30.2332 35.95 32.3499 34.15 34.1499C32.35 35.9499 30.2333 37.3749 27.8 38.4249C25.3667 39.4749 22.7667 39.9999 20 39.9999Z"
        fill="#F28334"
      />
    </svg>
  </i>
  <span class="font-bold modal-title mb-6 sm:mb-6 lg:mb-8">{{ 'profile.deleteAccount' | translate }}</span>
  <span class="font-light text-lg text-center">{{ 'profile.deletingYourAccount' | translate }}</span>
  <br />
  <span class="font-light text-lg mb-6 sm:mb-6 lg:mb-8 text-center">{{ 'profile.toProceedPlease' | translate }}</span>
  <korviu-input
    size="large"
    type="password"
    label="{{ 'profile.password' | translate }}"
    [control]="passwordControl"
    [errorMessages]="[{ errorCode: 'incorrect', localizedMessage: 'profile.password' }]"
  ></korviu-input>
  @if (!isPasswordCorrect) {
    <span class="incorrect-password">{{ 'profile.incorrectPassword' | translate }}</span>
  }
</div>
<div *nzModalFooter>
  <korviu-button color="tertiary" [disabled]="isLoading || passwordControl.invalid" (click)="onDeleteClick()">
    {{ 'profile.deleteAccount' | translate }}
  </korviu-button>
</div>

<ng-template #successMessageTemplate>
  <div class="flex flex-row gap-2 md:gap-1 lg:gap-1 px-2 md:px-3 lg:px-3 py-1 md:py-2 lg:py-2 rounded-lg items-center">
    <i nz-icon>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <mask
          id="mask0_12429_163049"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="16"
          height="16"
        >
          <rect width="16" height="16" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_12429_163049)">
          <path
            d="M7.06671 11.0667L11.7667 6.36666L10.8334 5.43333L7.06671 9.19999L5.16671 7.29999L4.23337 8.23333L7.06671 11.0667ZM8.00004 14.6667C7.07782 14.6667 6.21115 14.4917 5.40004 14.1417C4.58893 13.7917 3.88337 13.3167 3.28337 12.7167C2.68337 12.1167 2.20837 11.4111 1.85837 10.6C1.50837 9.78888 1.33337 8.92222 1.33337 7.99999C1.33337 7.07777 1.50837 6.21111 1.85837 5.39999C2.20837 4.58888 2.68337 3.88333 3.28337 3.28333C3.88337 2.68333 4.58893 2.20833 5.40004 1.85833C6.21115 1.50833 7.07782 1.33333 8.00004 1.33333C8.92226 1.33333 9.78893 1.50833 10.6 1.85833C11.4112 2.20833 12.1167 2.68333 12.7167 3.28333C13.3167 3.88333 13.7917 4.58888 14.1417 5.39999C14.4917 6.21111 14.6667 7.07777 14.6667 7.99999C14.6667 8.92222 14.4917 9.78888 14.1417 10.6C13.7917 11.4111 13.3167 12.1167 12.7167 12.7167C12.1167 13.3167 11.4112 13.7917 10.6 14.1417C9.78893 14.4917 8.92226 14.6667 8.00004 14.6667Z"
            fill="#0D9443"
          />
        </g>
      </svg>
    </i>
    <span class="message-content">
      {{ 'profile.accountSuccessfullyDeleted' | translate }}
    </span>
  </div>
</ng-template>
